import { CodedError } from './CodedError';
import { errorCodes } from './constants/errorCodes';

export default class InvalidVisitorScheduleRangeError extends CodedError {
  static get errorName() {
    return errorCodes.invalidVisitorScheduleRangeError.code;
  }

  constructor(
    message: string = errorCodes.invalidVisitorScheduleRangeError.message
  ) {
    super(message);
    this.code = errorCodes.invalidVisitorScheduleRangeError.code;
    this.message = `${message} ${errorCodes.invalidVisitorScheduleRangeError.code}`;
    this.name = errorCodes.invalidVisitorScheduleRangeError.name;
  }
}
